module.exports = __webpack_public_path__ + "img/check-circle.15cda8d4.svg";